type IArquivos = {
    arquivo: any;
    nome: string;
};

type ISubPasta = {
    titleSubPasta: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};
type TItem = {
    title: string;
    materiais: IMaterial[];
};

export const ListMateriasFVPortuguesPlanoAnual: TItem[] = [
    {
        title: 'Avaliação Formativa',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Língua Portuguesa',
                arquivos: [
                    {
                        nome: 'FV_LP_OrientacoesParaCorrecao_Aplicacao',
                        arquivo:
                            'FV_Materiais_2026/LINGUA PORTUGUESA/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/FV_LP_OrientacoesParaCorrecao_Aplicacao.pdf',
                    },
                    {
                        nome: 'FV-CARTA_Avaliação 2',
                        arquivo: 'FV_Materiais_2026/LINGUA PORTUGUESA/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/FV-CARTA_Avaliação 2.pdf',
                    },
                    {
                        nome: 'FV-CONTOS_Avaliação 3',
                        arquivo: 'FV_Materiais_2026/LINGUA PORTUGUESA/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/FV-CONTOS_Avaliação 3.pdf',
                    },
                    {
                        nome: 'FV-POEMAS_E_POESIAS_Avaliação 1',
                        arquivo: 'FV_Materiais_2026/LINGUA PORTUGUESA/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/FV-POEMAS_E_POESIAS_Avaliação 1.pdf',
                    },
                    {
                        nome: 'Quadro_habilidades_Avaliação 1_FV_LP',
                        arquivo:
                            'FV_Materiais_2026/LINGUA PORTUGUESA/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/Quadro_habilidades_Avaliação 1_FV_LP.pdf',
                    },
                    {
                        nome: 'Quadro_habilidades_Avaliação 2_FV_LP',
                        arquivo:
                            'FV_Materiais_2026/LINGUA PORTUGUESA/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/Quadro_habilidades_Avaliação 2_FV_LP.pdf',
                    },
                    {
                        nome: 'Quadro_habilidades_Avaliação 3_FV_LP',
                        arquivo:
                            'FV_Materiais_2026/LINGUA PORTUGUESA/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/Quadro_habilidades_Avaliação 3_FV_LP.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Materiais Didáticos',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Língua Portuguesa',
                subPastas: [
                    {
                        titleSubPasta: 'Livro Aluno',
                        arquivos: [
                            {
                                nome: 'FV_Carta_Aberta',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/MATERIAIS DIDÁTICOS/LÍNGUA PORTUGUESA/LIVRO ALUNO/FV_Carta_Aberta.pdf',
                            },
                            {
                                nome: 'FV_Contos_de_assombracao',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/MATERIAIS DIDÁTICOS/LÍNGUA PORTUGUESA/LIVRO ALUNO/FV_Contos_de_assombracao.pdf',
                            },
                            {
                                nome: 'FV_Poemas_Poesias',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/MATERIAIS DIDÁTICOS/LÍNGUA PORTUGUESA/LIVRO ALUNO/FV_Poemas_Poesias.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Livro Professor',
                        arquivos: [
                            {
                                nome: 'FV_Livro_do_Professor',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/MATERIAIS DIDÁTICOS/LÍNGUA PORTUGUESA/LIVRO PROFESSOR/FV_Livro_do_Professor.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: 'Teste Diagnóstico',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Língua Portuguesa',
                arquivos: [
                    {
                        nome: 'FV_POR_TESTE_DIAGNOSTICO_ALUNO',
                        arquivo: 'FV_Materiais_2026/LINGUA PORTUGUESA/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/FV_POR_TESTE_DIAGNOSTICO_ALUNO.pdf',
                    },
                    {
                        nome: 'FV_POR_TESTE_DIAGNOSTICO_ORIENTACOES',
                        arquivo:
                            'FV_Materiais_2026/LINGUA PORTUGUESA/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/FV_POR_TESTE_DIAGNOSTICO_ORIENTACOES.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Visão Geral Sistemática e Diretrizes',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'FV_CADERNO_DIRETRIZES',
                        arquivo: 'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/FV_CADERNO_DIRETRIZES.pdf',
                    },
                    {
                        nome: 'Visão geral_Fórmula da Vitória',
                        arquivo: 'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Visão geral_Fórmula da Vitória.pdf',
                    },
                    {
                        nome: 'Sistematica FORMULA DA VITÓRIA_LINGUA PORTUGUESA',
                        arquivo:
                            'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Sistematica FORMULA DA VITÓRIA_LINGUA PORTUGUESA.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Cartazes',
                        arquivos: [
                            {
                                nome: 'Cartaz de Acompanhamento Mensal IA_LP',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Cartazes/Cartaz de Acompanhamento Mensal IA_LP.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Tabelas',
                        arquivos: [
                            {
                                nome: 'FV_Acompanhamento_Bimestral_I',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Acompanhamento_Bimestral_I.pdf',
                            },
                            {
                                nome: 'FV_Acompanhamento_Bimestral_II',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Acompanhamento_Bimestral_II.pdf',
                            },
                            {
                                nome: 'FV_POR_Acompanhamento_Mensal_I_B',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_POR_Acompanhamento_Mensal_I_B.pdf',
                            },
                            {
                                nome: 'FV_POR_Acompanhamento_Mensal_II',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_POR_Acompanhamento_Mensal_II.pdf',
                            },
                            {
                                nome: 'FV_POR_Perfil_Turma_I',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_POR_Perfil_Turma_I.pdf',
                            },
                            {
                                nome: 'FV_POR_Perfil_Turma_II',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_POR_Perfil_Turma_II.pdf',
                            },
                            {
                                nome: 'FV_Resultado_Final_I',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Resultado_Final_I.pdf',
                            },
                            {
                                nome: 'FV_Resultado_Final_II',
                                arquivo:
                                    'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Resultado_Final_II.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
